import { v4 as uuidv4 } from 'uuid'

export const parseFullName = (firstName, lastName) => {
  if (firstName && lastName) return `${firstName} ${lastName} `

  if (firstName) return firstName

  if (lastName) return lastName

  return ''
}

export const capitalize = (string) => (
  string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
)

export const generateId = () => uuidv4()
